<ion-header>
	<app-app-header-menu
		[customer]="customer"
		[venue]="venue"
		[order]="order"
		(back)="showPopoverToBack($event)"
		[showGoToBasketBtn]="true"
		(showBasket)="toggleBasket()"
	></app-app-header-menu>
</ion-header>
<!-- BSG-compliant menu page with keyboard accessibility -->
<ion-content role="main">
	<!-- Skip link for keyboard navigation -->

	<ion-row class="main_row">
		<!-- Category sidebar - desktop view -->
		<ion-col
			*ngIf="largeScreen()"
			[sizeMd]="3"
			[sizeLg]="2"
			class="category_col ion-no-padding"
			#categoryList
			role="navigation"
			aria-label="Menu categories"
		>
			<ion-content>
				<!-- Menu filters -->
				<div class="filter-toggle">
					<app-menu-filters
						[selectedToggleTag]="selectedToggleTag"
						(toggleTagValue)="toggleTagValue($event)"
						tabindex="0"
					></app-menu-filters>
				</div>

				<!-- Category list with keyboard navigation -->
				<nav class="bsg-category-nav">
					<button
						*ngFor="let category of categories; let categoryIndex= index;"
						(click)="scrollTo(categoryIndex)"
						[class.first]="categoryIndex == 0"
						[class.last]="categoryIndex == categories.length -1"
						[class.selected]="selectedCategory && category._id === selectedCategory._id"
						class="category_item bsg-category-button"
						[attr.aria-pressed]="selectedCategory && category._id === selectedCategory._id"
						[attr.aria-label]="(category.name | langObservable | async) + ' category'"
						tabindex="0"
					>
						<ion-img *ngIf="category.assets.medium" [src]="category.assets.medium" alt aria-hidden="true"></ion-img>
						<ion-img
							*ngIf="!category.assets.medium"
							src="../../../assets/dean_and_david/logo.png"
							alt
							aria-hidden="true"
						></ion-img>
						<h3>{{ category.name | langObservable | async }}</h3>
					</button>
				</nav>
			</ion-content>
		</ion-col>
		<ion-col [size]="largeScreen()? 10: 12" [sizeMd]="9" [sizeLg]="10" class="catalog_col">
			<div class="filers_section">
				<ion-row role="region" aria-label="Content section">
					<ion-col class="ion-no-padding fix-hight" size="12" size-lg="12" *ngIf="!largeScreen()">
						<div class="venue_info_block" *ngIf="venue " role="region" aria-label="Venue information">
							<div>
								<h3>{{ venue?.street }} {{ venue?.city?.de }}</h3>
								<p>
									{{ 'preorder_type.' + order?.preorder?.type | translate }} · {{ time.toString() | date: 'dd. MMMM yyyy'
									}}
								</p>
							</div>
							<button (click)="showPopoverToBack($event)" class="bsg-edit-venue-button" aria-label="Edit venue">
								<ion-icon src="../../../assets/dean_and_david/edit_venue.svg" aria-hidden="true"></ion-icon>
							</button>
						</div>

						<!-- Mobile category chips -->
						<div
							#categoryList
							class="category-list"
							[class.hidden]="searchBarOpen"
							role="navigation"
							aria-label="Menu categories"
						>
							<ng-container *ngFor="let category of categories; let categoryIndex= index;">
								<button
									(click)="scrollTo(categoryIndex)"
									[class.selected]="selectedCategory && category._id === selectedCategory._id"
									class="chip category ion-margin-top ion-margin-bottom bsg-category-chip item-for-showing"
									[attr.aria-pressed]="selectedCategory && category._id === selectedCategory._id"
									tabindex="0"
								>
									<ion-img [src]="category.assets.medium" alt aria-hidden="true"></ion-img>
									<p>{{ category.name | langObservable | async }}</p>
								</button>
							</ng-container>
						</div>
					</ion-col>
					<ion-col class="search_col">
						<ion-searchbar
							#search
							[formControl]="searchForm"
							(ionClear)="clearInput()"
							searchIcon="/assets/dean_and_david/search.svg"
							clearIcon="/assets/eam/cross.svg"
							[placeholder]="'menu_page.search_placeholder' | translate"
							animated
							mode="md"
							aria-label="Search menu items"
						>
						</ion-searchbar>

						<!-- Filters button -->
						<button
							class="open_filters bsg-filters-button"
							(click)="showFilters = !showFilters"
							[attr.aria-expanded]="showFilters"
							[attr.aria-label]="showFilters ? 'Close filters' : 'Open filters'"
							tabindex="0"
						>
							<ion-icon src="../../../assets/dean_and_david/edit_filters.svg" aria-hidden="true"></ion-icon>
						</button>
					</ion-col>
				</ion-row>
			</div>
			<ion-content #articleContent (ionScroll)="onScroll($event)" [scrollEvents]="scrollEvents">
				<div *ngIf="categories.length === 0" class="no_items" role="region" aria-label="No categories available">
					<p>{{'menu_page.no_articles' | translate}}</p>
				</div>
				<ng-container *ngFor="let category of categories; let i = index; trackByCategory:trackBy">
					<ion-row class="item_row" *ngIf="selectedCategoryIndex === i" [attr.aria-labelledby]="'category-heading-' + i">
						<ion-col size="12">
							<h2 id="category-heading-{{i}}" class="bsg-visually-hidden">{{ category.name | langObservable | async }}</h2>
						</ion-col>
						<!-- Category heading (visually hidden) -->

						<!-- Menu items -->
						<ion-col
							[sizeLg]="4"
							[sizeMd]="4"
							size="12"
							*ngFor="let article of category.articles; trackBy: trackBy"
							class="bsg-menu-item-col"
						>
							<app-item-view
								[article]="article"
								(click)="openModal(article, category, true)"
								(keydown.enter)="openModal(article, category, true)"
								[categoryName]="category.name"
								[currency]="order?.currency"
								[hasOrder]="!!order"
								[preorderType]="preorderType"
								[orderValue]="order"
								[selectedToggleTag]="selectedToggleTag"
								class="item-responsive bsg-menu-item"
								tabindex="0"
								role="button"
								[attr.aria-label]="article.name"
							>
							</app-item-view>
						</ion-col>
						<div class="padding-80 more"></div>
					</ion-row>
				</ng-container>
			</ion-content>

			<div class="order_basket_block" [class.open]="isOpenBasket$ | async" role="region" aria-label="Order basket section">
				<ion-row class="order_basket_header" role="region" aria-label="Order Basket Header">
					<ion-col class="close_basket_col"> {{ "menu_page.close_basket" | translate }} </ion-col>
					<ion-col size="auto" class="close_basket_img_col" (click)="toggleBasket()">
						<ion-img class="close_basket_img" src="../../../assets/eam/cross_button.svg" alt="" aria-hidden="true"></ion-img>
					</ion-col>
				</ion-row>
			</div>
		</ion-col>
	</ion-row>

	<!-- Filters panel -->
	<div
		class="filters_section"
		[class.show-filters]="showFilters"
		role="dialog"
		[attr.aria-hidden]="!showFilters"
		aria-label="Menu filters"
	>
		<app-menu-list-filters (selectedFilters)="selectedFilters($event)" tabindex="0"> </app-menu-list-filters>
	</div>
</ion-content>

<div class="order_basket_block" [class.open]="isOpenBasket$ | async" role="region" aria-label="Order basket block">
	<div class="order_list_row" role="region" aria-label="Order list row">
		<app-order-content [fromMenu]="true" (closeOrderContent)="isOpenBasket$.next(false)"></app-order-content>
	</div>
</div>
<ion-content *ngIf="!categories">
	<ion-row class="center">
		<ion-spinner *ngIf="searchTerm.length === 0" name="crescent"></ion-spinner>
		<div *ngIf="searchTerm.length > 0" class="bold font-16" role="region" aria-label="Search term result">{{'' | translate}}</div>
	</ion-row>
</ion-content>
<ion-footer *ngIf="active && !largeScreen() && !showFilters" class="footer-btn">
	<app-to-order-button [order]="order"></app-to-order-button>
</ion-footer>
